export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
    visible: that.multiple
  },
  {
    field: 'radio',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'radio',
    visible: !that.multiple
  },
  {
    title: that.$l('table_label_user_name_en') || '英文姓名',
    field: 'userNameEn',
    minWidth: 140,
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_user_name') || '中文姓名',
    field: 'userName',
    minWidth: 120,
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_user_status') || '账号状态',
    field: 'userStatus',
    width: 100,
    align: 'center',
    slots: { default: 'userStatus' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_inspector_role') || '验货角色',
    field: 'inspectorRole',
    width: 120,
    align: 'center',
    slots: { default: 'inspectorRole' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_dep_name') || '所在部门',
    field: 'depName',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_org_name') || '所属公司',
    field: 'orgName',
    minWidth: 220,
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_mobileNumber') || '手机号',
    field: 'mobileNumber',
    minWidth: 130,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_emailAddress') || '邮箱地址',
    field: 'emailAddress',
    minWidth: 220,
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_displayCreate') || '创建人',
    field: 'displayCreate',
    width: 170,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'displayCreate' },
  },
  {
    title: that.$l('table_label_displayModify') || '修改人',
    field: 'displayModify',
    width: 170,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'displayModify' },
  },
]
